import { Component, Inject, Input, OnInit } from '@angular/core';
import { VerificationStatus } from '../../services/verification.model';
import { UserProfile } from '../../services/yeti-protocol/auth/mi';
import { ResponsiveUtilsService } from '../../services/utils/responsive-utils.service';
import { AuthService } from '../../services/auth/auth.service';
import { CONTEXT_DIALOGS_UI, ContextDialogsUI } from '../../services/dialogs/dialogs.ui.interface';
import { ActionSource } from '../../services/yeti-protocol/tracking';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MIComponentsModule } from '../components.module';
import { LayoutModule } from 'src/app/modules/layout/layout.module';
import { TopBarModule } from 'src/app/modules/top-bar/top-bar.module';

@Component({
  selector: 'app-profile-page-template',
  templateUrl: './profile-page-template.component.html',
  styleUrls: ['./profile-page-template.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    MIComponentsModule,
    LayoutModule,
    TopBarModule
  ]
})
export class ProfilePageTemplateComponent implements OnInit {

  @Input() topBarTitle: string;

  profile: UserProfile;
  profileIsVerified: boolean;
  ActionSource = ActionSource;

  constructor(
    private responsiveUtilsService: ResponsiveUtilsService,
    private authService: AuthService,
    @Inject(CONTEXT_DIALOGS_UI) private dialogs: ContextDialogsUI,
  ) { }

  ngOnInit(): void {
    this.authService.userProfileAsObservable.subscribe(userProfile => {
      this.profile = userProfile;
      this.profileIsVerified = userProfile && userProfile.verificationStatus === VerificationStatus.VERIFIED;
    });
  }

  onEditProfile(): void {
    this.dialogs.editCurrentUserProfile()
      .then(data => {
        if (data) {
          this.profile = data;
        }
      });
  }
  get isDesktop(): boolean {
    return this.responsiveUtilsService.isDesktop;
  }

}
